/***                              ***/
/*** FILTER STATE CONTROLLERS    ***/
/***                             ***/
let checkedFilters = {
    workouttypes: [],
    city: [],
    conveniences: []
};
let filterMatrix = {};

// Needed for cities which has (Workouts but no Conveniences and vice versa)
const fallbackFilter = "0";

const acceptBtn = document.getElementById('facility-filter-accept-btn');
const resetBtn = document.getElementById('facility-filter-reset-btn');
const filterBtn = document.getElementById('facility-filter-btn');
const modal = document.getElementById('facility-filter-modal');
const overlay = document.getElementById('facility-overlay');
const closeModalBtn = document.getElementById('facility-close-modal-btn');
const filterCountSpan = document.getElementById('facility-filter-count');

// Updates URL && counter -- toLowerCase() --
const updateURL = (mapCheck) => {
    const urlParams = utils.url.checkUrlParams(Object.keys(checkedFilters), true);
    let appliedFiltersCount = 0;
    const checkboxes = getAllCheckboxes();
    checkboxes.forEach(checkbox => {
        const paramName = checkbox.dataset.id;
        const paramValue = checkbox.dataset.value;

        if (checkbox.checked) {
            appliedFiltersCount++;
        }
        utils.url.updateURLParameter(urlParams, paramName, paramValue, checkbox.checked);
    });

    const noFiltersApplied =
        checkedFilters['workouttypes'].length === 0 &&
        checkedFilters['city'].length === 0 &&
        checkedFilters['conveniences'].length === 0;

    let newUrl;
    if (noFiltersApplied) {
        if (mapCheck || urlParams.has('map')) {
            urlParams.set('map', 'true');
            newUrl = utils.url.decodedUrl(urlParams);
            handleFilterReset();
        } else {
            newUrl = window.location.pathname;
        }
    } else {
        newUrl = utils.url.decodedUrl(urlParams);
    }

    window.history.replaceState({}, '', newUrl);
    applyFilters(false, appliedFiltersCount !== 0);

    if (filterCountSpan) utils.common.updateFilterButton(appliedFiltersCount, filterCountSpan);
    if (mapCheck || urlParams.has('map')) {
        handleUrlParameters();
    }
};

// Open filter Modal
const openModal = () => {
    utils.common.showElement(modal);
    utils.common.showElement(overlay);
    utils.modal.trapFocus(modal);
    checkmarkBoxes();
    updateFilter();
    filterBtn.setAttribute('aria-expanded', "true");
    overlay.setAttribute("aria-hidden", "false");
    closeModalBtn.setAttribute("aria-expanded", "true");
};

// Close filter Modal
const closeModal = () => {
    utils.common.hideElement(modal);
    utils.common.hideElement(overlay);
    filterBtn.setAttribute('aria-expanded', "false");
    overlay.setAttribute("aria-hidden", "true");
    closeModalBtn.setAttribute("aria-expanded", "false");
    utils.modal.removeTrapFocus();
};

const applyFilters = () => {
    const filterCountSpan = document.getElementById('facility-filter-count');
    const urlParams = utils.url.checkUrlParams(Object.keys(checkedFilters), true);

    // Count applied filters
    let appliedFiltersCount = 0;

    urlParams.forEach((value, key) => {
        if (key in checkedFilters) {
            appliedFiltersCount += value.split(',').length; // Count comma-separated values
        }
    });

    // Update filter button count
    if (filterCountSpan) utils.common.updateFilterButton(appliedFiltersCount, filterCountSpan);

};

// Updates checkboxes -- toLowerCase to always be sure that everything stays the same
const checkmarkBoxes = () => {
    const urlParams = utils.url.checkUrlParams(Object.keys(checkedFilters), true)
    const checkboxes = getAllCheckboxes();
    checkboxes.forEach(checkbox => {
        const paramName = checkbox.dataset.id;
        const checkboxValue = checkbox.dataset.value;
        checkbox.addEventListener('change', updateFilterOptions);
        if (urlParams.has(paramName) && urlParams.get(paramName).split(',').includes(checkboxValue)) {
            checkbox.checked = true;
            if (!checkedFilters[paramName].includes(checkboxValue)) {
                checkedFilters[paramName].push(checkboxValue)
            }
        }
    });
};

const getSelectedCityId = (checkboxes) => {
    const selectedCityName = checkedFilters.city[0]?.toLowerCase();
    const matchingCityCheckbox = [...checkboxes].find(cb =>
        cb.dataset.id === 'city' &&
        cb.dataset.value?.toLowerCase() === selectedCityName
    );
    return matchingCityCheckbox?.id;
};

const hasHitInCity = (city, selectedConveniences = [], selectedWorkoutTypes = []) => {
    // If nothing selected show all
    if (selectedConveniences.length === 0 && selectedWorkoutTypes.length === 0) return true;

    if (selectedWorkoutTypes.length === 0) {
        return selectedConveniences.every(convenienceId => {
            const workouts = city[convenienceId] || city[fallbackFilter];
            return workouts && Object.values(workouts).some(val => val > 0);
        });
    }

    // If only workouts are selected
    if (selectedConveniences.length === 0) {
        return selectedWorkoutTypes.every(workoutId => {
            return Object.values(city).some(workouts => workouts[workoutId] > 0);
        });
    }

    // Main check -- check for all (convenience + workout)
    return selectedConveniences.every(convenienceId => {
        const workouts = city[convenienceId] || city[fallbackFilter];
        if (!workouts) return false;

        return selectedWorkoutTypes.every(workoutId => workouts[workoutId] > 0);
    });
};

const hasHitInConvenience = (cityToScan, convenienceId) => {
    return Object.entries(cityToScan).some(([_, city]) => {
        if (!hasHitInCity(city, checkedFilters.conveniences, checkedFilters.workouttypes)) return false;

        const workouts = city[convenienceId] || city[fallbackFilter];
        if (!workouts) return false;

        return checkedFilters.workouttypes.length === 0
            ? Object.values(workouts).some(val => val > 0)
            : checkedFilters.workouttypes.some(workoutId => workouts[workoutId] > 0);
    });
};

const hasHitInWorkoutType = (cityToScan, workoutTypeId) => {
    return Object.entries(cityToScan).some(([_, city]) => {
        if (!hasHitInCity(city, checkedFilters.conveniences, checkedFilters.workouttypes)) return false;

        const convenienceIds = checkedFilters.conveniences.length > 0
            ? checkedFilters.conveniences
            : Object.keys(city);

        return convenienceIds.some(convenienceId => {
            const workouts = city[convenienceId] || city[fallbackFilter];
            return workouts?.[workoutTypeId] > 0;
        });
    });
};

const updateVisibility = () => {
    const checkboxes = getAllCheckboxes();
    const selectedCityId = getSelectedCityId(checkboxes);

    // Check if user have selected a filter -- otherwise use full matrix
    const cityToScan = selectedCityId
        ? { [selectedCityId]: filterMatrix[selectedCityId] }
        : filterMatrix;

    checkboxes.forEach(checkbox => {
        const type = checkbox.dataset.id;
        const value = checkbox.id;

        // Always keep checked filters enabled
        if (checkedFilters[type].includes(value)) {
            checkbox.disabled = false;
            return;
        }

        if (type === 'city') {
            if (selectedCityId) {
                checkbox.disabled = checkbox.id !== selectedCityId;
                return;
            }

            const city = filterMatrix[value];

            checkbox.disabled = !hasHitInCity(
                city,
                checkedFilters.conveniences,
                checkedFilters.workouttypes
            );
            return;
        }

        if (type === 'conveniences') {
            checkbox.disabled = !hasHitInConvenience(cityToScan, value);
            return;
        }

        if (type === 'workouttypes') {
            checkbox.disabled = !hasHitInWorkoutType(cityToScan, value);
            return;
        }
    });
};

const updateFilterOptions = (event) => {
    const value = event.target.getAttribute('data-value');
    const type = event.target.getAttribute('data-id');
    const isChecked = event.target.checked;

    if (isChecked) {
        if (!checkedFilters[type].includes(value)) {
            checkedFilters[type].push(value);
        }
    } else {
        const index = checkedFilters[type].indexOf(value);
        if (index > -1) {
            checkedFilters[type].splice(index, 1);
        }
    }

    updateFilter();
};

const updateFilter = () => {
    // Reset filters if all checked filters are empty
    if (
        checkedFilters['city'].length === 0 &&
        checkedFilters['conveniences'].length === 0 &&
        checkedFilters['workouttypes'].length === 0
    ) {
        return resetAllFilters();
    }

    // Check which inputs that needs to be disabled.
    updateVisibility();
};

/***                    ***/
/***** FILTER HELPERS *****/
/***                   ***/

// Function to reset all filters and show all options
const resetAllFilters = () => {
    // Reset checkedFilters to be empty
    checkedFilters = {
        workouttypes: [],
        city: [],
        conveniences: []
    };
    searchTermState = null;
    const checkboxes = getAllCheckboxes();
    findExerciseLocationMap.savedInputValue = null;
    checkboxes.forEach(element => {
        element.disabled = false;
        element.checked = false;
    });
};

const initMatrix = async () => {
    const data = await fetchMatrix();
    if (data) {
        filterMatrix = data;
    }
};

document.addEventListener('DOMContentLoaded', () => {

    initMatrix().then(() => {
        filterBtn?.addEventListener("click", openModal);
        closeModalBtn?.addEventListener("click", closeModal);
        overlay?.addEventListener("click", closeModal);
        acceptBtn?.addEventListener("click", () => {
            updateURL(mapCheck());
            window.loadMoreFacilities(true);
            searchTermState = null;
            closeModal();
        });

        resetBtn?.addEventListener("click", () => {
            resetAllFilters();
        });
    });
});
